export default function filterAndSort(filtered, filters, featured = false) {

  // filter by terminal
  if (filters.terminal) {

    filtered = filtered.filter(item => {
      return item.product.group_terminal.indexOf(filters.terminal) > -1
    })
  }

  // filter by type
  if (filters.type) {
  
    filtered = filtered.filter(item => {

      const filtersLit = {
        chauffeur: item.product.park_type === 'Chauffeur',
        on: parseInt(item.product.on_airport),
        off: !parseInt(item.product.on_airport)
      };
      return filtersLit[filters.type.toLowerCase()]
    })
  }

  // sort by price or recommended
  filtered = filtered.sort((a, b) => {

    // recommened sort 	
    // 1) sort by price if its set at 0. 	
    // 2) sort by featured quote flag	
    // 3) sort by priority	  
    // 4) sort by featured	
    // 5) sort by price 	

    const sortList = {
      'recommended': 
        (parseFloat(b.product.price) == 0) - (parseFloat(a.product.price) == 0)
        || (parseInt(b.product.product_id) === parseInt(featured)) - (parseInt(a.product.product_id) === parseInt(featured))
        || parseInt(b.product.priority) - parseInt(a.product.priority) 
        || parseInt(b.product.featured_product) - parseInt(a.product.featured_product) 
        || parseFloat(a.product.price) - parseFloat(b.product.price),
      'price-low': parseFloat(a.product.price) - parseFloat(b.product.price),
      'price-high': parseFloat(b.product.price) - parseFloat(a.product.price),
    };
    return sortList[filters.sort]
  })

  return filtered;
}